import { createFileRoute } from "@tanstack/react-router";
import { LocationPage, locationImages, locationJsonLd } from "@/components/LocationPage";

export const config = {
  slug: "sohna-road-gurugram",
  tagline:
    "Healic's flagship multispecialty hospital on Sohna Road — modern OTs, ICU, and on-call senior consultants serving Badshahpur, Sector 68 and South Gurugram.",
  hours: "24*7 Open\u00a0",
  highlights: [
    "Flagship Gurugram unit with modular OTs",
    "Cardiology, ENT & General Surgery under one roof",
    "Cashless insurance & TPA tie-ups",
    "Easy access from Sohna Road & Golf Course Ext.",
  ],
  faqs: [
    { q: "Is the Sohna Road hospital open 7 Am to 12 Am?", a: "Yes, the emergency room and ICU operate from 7 Am to 12 Am with on-call surgeons and intensivists." },
    { q: "Do you accept cashless insurance?", a: "We are empanelled with major TPAs and insurers — call our helpdesk to confirm your policy." },
    { q: "Can I book a same-day consultation?", a: "Yes, walk-in and same-day OPD slots are available; booking online is recommended to reduce wait." },
    { q: "Which areas does this branch serve?", a: "Badshahpur, Sector 67–72, Sohna Road, South City, Golf Course Ext. and nearby." },
  ],
};

export const Route = createFileRoute("/locations/sohna-road-gurugram")({
  head: () => ({
    meta: [
      { title: "Healic Multispeciality Hospital Sohna Road, Gurugram — Multispecialty Care" },
      { name: "description", content: "7 Am to 12 Am emergency, ICU, OPD, surgery and diagnostics at Healic Hospital Sohna Road, Gurugram. Book a consultation today." },
      { property: "og:title", content: "Healic Multispeciality Hospital Sohna Road, Gurugram" },
      { property: "og:description", content: "Modern multispecialty care on Sohna Road — surgery, cardiology, ENT, diagnostics and 7 Am to 12 Am emergency." },
      { property: "og:url", content: "https://healic.in/locations/sohna-road-gurugram" },
      { property: "og:image", content: locationImages["sohna-road-gurugram"] },
    ],
    links: [{ rel: "canonical", href: "https://healic.in/locations/sohna-road-gurugram" }],
    scripts: locationJsonLd(config),
  }),
  component: () => <LocationPage config={config} />,
});
